import { addDays, endOfDay, startOfDay } from 'date-fns'
import { fromZonedTime, toZonedTime } from 'date-fns-tz'

// Note: the date pickers on the Reservations / Time Blocks tabs work with calendar days - a Date
// whose local fields are the building's date - while the filters and API params hold real
// epoch instants. These helpers are the only place the two are converted, always in the
// building's timezone, so the browser's timezone never leaks into a day boundary.

export const getBuildingToday = (timezone: string, now: Date = new Date()): Date =>
  startOfDay(toZonedTime(now, timezone))

export const toBuildingDay = (epochMs: number, timezone: string): Date =>
  startOfDay(toZonedTime(epochMs, timezone))

export const getDayStartEpoch = (day: Date, timezone: string): number =>
  fromZonedTime(startOfDay(day), timezone).getTime()

export const getDayEndEpoch = (day: Date, timezone: string): number =>
  fromZonedTime(endOfDay(day), timezone).getTime()

export const toBuildingMidnight = (epochMs: number, timezone: string): number =>
  getDayStartEpoch(toBuildingDay(epochMs, timezone), timezone)

// Note: `days` counts calendar days including today (days = 7 -> today .. today + 6), ending at
// the end of the last day - the same span as the "Next N days" period preset.
export const getDefaultDateRange = (
  timezone: string,
  days: number,
  now: Date = new Date(),
): [number, number] => {
  const today = getBuildingToday(timezone, now)
  return [getDayStartEpoch(today, timezone), getDayEndEpoch(addDays(today, days - 1), timezone)]
}
